import { render, staticRenderFns } from "./TaxClassificationForm.vue?vue&type=template&id=794d94aa&"
import script from "./TaxClassificationForm.vue?vue&type=script&lang=js&"
export * from "./TaxClassificationForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('794d94aa')) {
      api.createRecord('794d94aa', component.options)
    } else {
      api.reload('794d94aa', component.options)
    }
    module.hot.accept("./TaxClassificationForm.vue?vue&type=template&id=794d94aa&", function () {
      api.rerender('794d94aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/invoice/parameters/components/TaxClassificationForm.vue"
export default component.exports